import * as React from "react";
import type { SVGProps } from "react";
const SvgPegasus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#e31f26"
      fillRule="evenodd"
      d="m3 42.5 13.708-31.635a.8.8 0 0 0 .047-.209c.009-.453-.342-.687-.563-.783-.515-.199-.845-.621-.845-1.125 0-.689.678-1.248 1.514-1.248h14.914l8.538.026c2.599 0 4.896 1.519 5.853 3.748.548 1.356.834 2.822.834 4.376 0 2.443-.758 4.712-2.042 6.591-2.751 4.048-7.26 6.473-12.13 6.473H22.522l-4.56 10.634c-.022.06-.06.137-.06.21 0 .253.182.473.399.57.519.195.845.62.845 1.12 0 .693-.676 1.252-1.512 1.252zm21.373-17.92 5.782-13.334s.922-.024 1.232.024c.634.1 1.118.247 1.619.537 2.315 1.351 2.492 5.187.395 8.57-1.59 2.569-3.9 4.17-6.772 4.19z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPegasus;
